import { Avatar, IconButton } from "@material-ui/core";
import { Rating } from "@material-ui/lab";
import React from "react";
import { truckGreyIconImage } from "../../../../assets";
import { s3baseUrl } from "../../../../bl_libs/invokeApi";

function Aboutprofile(props) {
  const { comapny_profile, truck_count, company_rating } = props;
  const { about_company, name, profile_picture } = comapny_profile;

  return (
    <>
      <div className="heading-wrapper black-bg text-center">
        <span>
          <h6 className="text-white">About</h6>
        </span>
      </div>
      <div className="rounded-box profile-about scrolling">
        <div className="request-left-box p-3 p-sm-4">
          {/* <div className="row justify-content-center">
          <div className="col-12">
            <div className="form-group text-center">
              <Avatar
                style={{
                  width: 150,
                  height: 150,
                  fontSize: 22,
                  marginLeft: "auto",
                  marginRight: "auto",
                }}
              ></Avatar>
            </div>
          </div>
          <div className="col-12 text-center">
            <h3>Company name</h3>
          </div>
        </div> */}

          <div className="row justify-content-center">
            <div className="col-12 font-weight-bold border-bottom">
              <div className="row">
                <div className="col-12 text-center">
                  {profile_picture ? (
                    <img
                      style={{
                        width: 150,
                        height: 150,
                        borderRadius: "50%",
                      }}
                      src={s3baseUrl + profile_picture}
                    ></img>
                  ) : (
                    <Avatar
                      style={{
                        width: 150,
                        height: 150,
                        fontSize: 22,
                        marginLeft: "auto",
                        marginRight: "auto",
                      }}
                    >
                      {/* {name[0].toUpperCase()} */}
                    </Avatar>
                  )}
                </div>
                <div className="col-12 pt-30">
                  <div className="row">
                    <div className="col-12">
                      <span>{name}</span>
                    </div>
                    <div className="col-12">
                      <span className="small-grey-text mr-1">
                        {truck_count}
                      </span>
                      <img src={truckGreyIconImage}></img>
                      <span className="small-grey-text ml-2">
                        Rating {company_rating}
                      </span>
                      <Rating
                        className="align-bottom pl-md-2 pb-1"
                        value={company_rating}
                        precision={0.1}
                        readOnly
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 pt-20">
              <p className="font-weight-bold">About</p>
              <div className="small-font-size">
                {about_company ? about_company : "N/A"}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Aboutprofile;
